<!--
/*
 * @Author: your name
 * @Date: 2021-07-05 20:00:34
 * @LastEditTime: 2022-11-16 15:20:13
 * @LastEditors: 谢树和 shuhe.xie@southgis.com
 * @Description: In User Settings Edit
 * @FilePath: \maine:\git\xadc\src\views\JobUnitQuery\JobUnitQueryDetail.vue
 * @Description: 测绘作业单位查询 - 详情
 */
 -->
<template>
  <div id="job-unit-query-detail" class="job-unit-query-detail">
    <div class="detail-box-tab">
      <div
        v-for="(item, index) in tabList"
        :key="index"
        :class="
          active == index
            ? 'detail-box-tab-name activeTab'
            : 'detail-box-tab-name'
        "
        @click="onTabClick(index)"
      >
        {{ item.name }}
      </div>
    </div>
    <div
      :class="
        active == 0 ? 'detail-box-content isOverflow' : 'detail-box-content'
      "
    >
      <div class="detail-box-content-name">{{ unitName }}</div>
      <div v-if="active == 0" class="detail-info">
        <div class="cell-box" v-for="(item, idx) in rowsList" :key="idx">
          <div v-for="(column, index) in columns" :key="index">
            <van-cell
              :title="column.label"
              :value="item[column.key]"
              :border="false"
              title-class="cell-box-title"
              value-class="cell-box-value"
              class="cell-box-item"
              v-if="index < columns.length - 1"
            />
          </div>
        </div>
      </div>
      <div v-else-if="active == 1" class="qualified-info">
        <div class="qualified-info-head">
          <img
            src="@/assets/img/jobUnitQuery/zongyewuliang.png"
            class="head-icon"
          />
          <span class="head-title">总业务量</span>
          <span class="head-count">{{ count }}</span>
        </div>
      </div>
      <div v-else-if="active == 2" class="project-info">
        <div class="project-info-head">
          <img
            src="@/assets/img/jobUnitQuery/jiebanzongshuliang.png"
            class="head-icon"
          />
          <span class="head-title">接办项目总数量</span>
          <span class="head-count">{{ zywl }}</span>
        </div>
      </div>
      <div v-else-if="active == 3">
        <div class="credit-info-head">
          <div class="credit-info-head-left">
            <img
              src="@/assets/img/jobUnitQuery/xinyongpingjiadengji.png"
              class="credit-icon"
            />
            <div>
              <div class="credit-title">信用评价等级</div>
              <div class="credit-grade">{{ xypjdj }}</div>
            </div>
          </div>
          <div class="credit-info-head-right">
            <img
              src="@/assets/img/jobUnitQuery/xinyongpingjiafenshu.png"
              class="credit-icon"
            />
            <div>
              <div class="credit-title">信用评价分数</div>
              <div class="credit-fraction">{{ xypjfs }}</div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="active != 0"
        :class="{
          'zz-info-list': active == 1,
          'pro-info-list': active == 2,
          'credit-info-list': active == 3
        }"
      >
        <div v-if="rowsList.length == 0">
          <no-data :msg="active == 3 ? '暂无扣分记录' : '暂无结果'"></no-data>
        </div>
        <div v-else>
          <van-pull-refresh
            v-model="refreshConfig.refreshing"
            @refresh="onRefresh"
          >
            <van-list
              v-model="refreshConfig.loading"
              :finished="refreshConfig.finished"
              :finished-text="refreshConfig.finishedText"
              :error.sync="refreshConfig.error"
              :error-text="refreshConfig.errorText"
              @load="onLoad"
            >
              <div
                class="cell-box"
                v-for="(item, index) in rowsList"
                :key="index"
              >
                <van-cell
                  :title="column.label"
                  :value="item[column.key]"
                  :border="false"
                  v-for="column of columns"
                  :key="column.key"
                  :title-style="{width: '25%'}"
                  title-class="cell-box-title"
                  value-class="cell-box-value"
                  class="list-cell-box-item"
                />
              </div>
            </van-list>
          </van-pull-refresh>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NoData from '@/components/NoData.vue'
import listMixins from '@/mixins/comListMixins'
import api from '@/utils/api/jobUnitQuery.api.js'
import moduleMixins from '@/mixins/moduleMixins'
export default {
  name: 'jobUnitQueryDetail',
  mixins: [listMixins, moduleMixins],
  components: {
    NoData
  },
  props: {},
  data() {
    return {
      tabList: [
        {
          name: '详细信息'
        },
        {
          name: '资质信息'
        },
        {
          name: '项目信息'
        },
        {
          name: '信用信息'
        }
      ], // 标签栏列表
      active: 0, // 当前选中的标签的索引值
      unitName: '', // 单位名称
      rid: '', // 测绘作业单位查询项-rid
      count: null, // 总业务量
      loading: false, //加载
      finished: false, //是否已加载完成
      refreshing: false, //下拉刷新
      columns: [], // 列表子项的左侧标题数组
      rowsList: [], // 信息列表
      zywl: null, // 接办项目总数量
      xypjfs: null, // 信用评价分数
      xypjdj: '', // 信用评价等级
      userid: ''
    }
  },
  watch: {},
  computed: {
    navTitle() {
      return '测绘作业单位详情'
    }
  },
  methods: {
    // 点击每一项标签触发
    onTabClick(idx) {
      // 点击同个tab的时候不用重新请求
      if(this.active == idx) {
        return
      }
      this.active = idx
      // this.columns = []
      this.rowsList = []
      if (this.active == 0) {
        this.getJobUnitQueryDetail()
      } else {
        this.onRefresh()
      }
    },
    // 获取测绘单位详情信息
    getJobUnitQueryDetail() {
      let params = {
        id: this.rid
      }
      api.getJobUnitQueryDetail(params).then(res => {
        this.columns = res.data.columns
        this.rowsList = res.data.rowsList
      })
    },
    // 获取测绘作业单位资质信息/项目信息/信用信息
    loadData(data) {
      console.log('data', data)
      let params = {}
      if (this.active == 1) {
        //资质信息
      } else {
        params = {
          page: data.page,
          rows: data.rows,
          rid: this.rid
        }
      }
      params = {
        page: data.page,
        size: data.rows,
        //   rid: 'b79ba6d5-00c2-42db-ae0c-2298f77a0dc6',
        //   userid: '5601b1f9-b9b3-47f4-bf83-a9296833e3a5'
        //   rid: '006ca772-e514-4ffd-a755-eacc203f7dc9' //有信用信息
        rid: this.rid,
        userid: this.userid
      }
      if (this.active == 1) {
        // 获取测绘作业单位资质信息
        return api.getListPageLike(params).then(res => {
          console.log('--res', res.data.zzData)
          let data = res.data.zzData
          //处理数据
          let arr = data['columns'].filter(
            item => !data['hideColumns'].includes(item.key)
          )
          this.columns = arr
          this.count = res.data.ywData.amount // 总业务量
          if (data.page == 1) {
            this.rowsList = data.rowsList
          } else {
            this.rowsList.push(...data.rowsList)
          }
          // if (data.rowsList.length == 0) {
          //   this.finished = true
          // } else {
          //   this.finished = data.rowsList.length < data.total
          // }
          // console.log('finished', this.finished)
          this.refreshConfig.finished = this.rowsList.length >= data.total
          return Promise.resolve(res)
        })
      } else if (this.active == 2) {
        // 获取测绘作业单位项目信息
        return api.getProjectInfoByRid(params).then(res => {
          console.log('--res', res.data.xmData)
          let data = res.data.xmData
          // this.loading = false
          //处理数据
          let arr = data['columns'].filter(
            item => !data['hideColumns'].includes(item.key)
          )
          this.columns = arr
          this.zywl = res.data.ywData.amount
          if (data.page == 1) {
            this.rowsList = data.rowsList
          } else {
            this.rowsList.push(...data.rowsList)
          }
          //处理
          // if (data.rowsList.length == 0) {
          //   this.finished = true
          // } else {
          //   this.finished = data.rowsList.length < data.total
          // }
          this.refreshConfig.finished = this.rowsList.length >= data.total
          return Promise.resolve(res)
        })
      } else if (this.active == 3) {
        // 获取测绘作业单位信用信息
        return api.getCreditInfoByRid(params).then(res => {
          console.log('--res', res.data.blxxMap)
          let data = res.data.blxxMap
          // this.loading = false
          let arr = data['columns'].filter(
            item => !data['hideColumns'].includes(item.key)
          )
          this.columns = arr
          this.xypjfs = res.data.upMap.rowsList[0].xydjfs // 信用评价分数
          this.xypjdj = res.data.upMap.rowsList[0].xydj // 信用评价等级
          if (data.page == 1) {
            this.rowsList = data.rowsList
          } else {
            this.rowsList.push(...data.rowsList)
          }
          this.refreshConfig.finished =
            this.rowsList.length >= data.total
          return Promise.resolve(res)
        })
      }
    },
    _loadData(data) {
      return this.loadData(data)
        .then(res => {
          // console.log('resss', res)
          this.refreshConfig.curPage = data.page
          // if (res.rowsList.length == 0 && data.page == 1) {
          //   // this.refreshConfig.finished = false;
          //   this.refreshConfig.finishedText = ''
          // } else {
          this.refreshConfig.finishedText = '没有更多了'
          // }
          // if (res.rowsList.length < data.rows) {
          //   this.refreshConfig.finished = true
          // }
          this.refreshConfig.loading = false
          return Promise.resolve(res)
        })
        .catch(err => {
          this.refreshConfig.error = true
        })
    },
    onLoad() {
      console.log('jobUnit-onLoad')
      let nextPage = this.refreshConfig.curPage + 1
      let data = {
        page: nextPage,
        rows: 10
      }
      this._loadData(data).then(res => {
        this.refreshConfig.refreshing = false
      })
    },
    onRefresh() {
      // this.columns = []
      this.rowsList = []
      console.log('comlist-onRefresh')
      this.refreshConfig.finished = false
      let nextPage = 1
      let data = {
        page: nextPage,
        rows: 10
      }
      this.refreshConfig.loading = true
      this.refreshConfig.error = false
      this._loadData(data).then(res => {
        this.refreshConfig.refreshing = false
      })
    }
  },
  created() {
    // this.onRefresh()
    this.unitName = this.$route.query.unitName
    this.rid = this.$route.query.rid
    this.userid = this.$route.query.userid
    this.getJobUnitQueryDetail()
  },
  mounted() {}
}
</script>
<style lang="scss" scoped>
.job-unit-query-detail {
  background: #ffffff;
  height: 100vh;
  overflow: auto;
  .detail-box-tab {
    display: flex;
    width: 100%;
    align-items: center;
    border-top: 1px solid #dddddd;
    border-bottom: 1px solid #dddddd;
    .detail-box-tab-name {
      display: flex;
      flex: 1;
      padding: 13px 0px;
      align-items: center;
      justify-content: center;
      border-left: 1px solid #dddddd;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #666666;
    }
    .activeTab {
      font-weight: bold;
      color: #1d84ff;
    }
  }
  .detail-box-content {
    height: calc(100% - 47px);
    .detail-box-content-name {
      font-size: 17px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #222222;
      padding: 23px 0px 20px 0px;
      text-align: center;
    }

    .cell-box {
      margin-top: 15px;
      .cell-box-item {
        padding: 0px 16px 16px 16px;
      }
      .list-cell-box-item {
        padding: 16px 16px 0px 16px;
      }
      .list-cell-box-item:last-child {
        padding-bottom: 16px;
      }
      .cell-box-title {
        // width: 25%;
        width: 33%;
        flex: none;
        justify-content: flex-end;
        display: flex;
        white-space: pre-line;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #999999;
      }
      .cell-box-value {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333333;
        justify-content: flex-start;
        display: flex;
        width: 75%;
        padding-left: 20px;
        text-align: left;
      }
    }

    .qualified-info,
    .project-info {
      .qualified-info-head,
      .project-info-head {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-bottom: 15px;
        .head-icon {
          width: 30px;
          height: 30px;
        }
        .head-title {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #333333;
          padding: 0px 20px;
        }
        .head-count {
          font-size: 20px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #333333;
        }
      }
    }
    .zz-info-list {
      background: #f1f3f6;
      height: calc(100% - 110px);
      overflow: auto;
    }
    .pro-info-list {
      background: #f1f3f6;
      height: calc(100% - 110px);
      overflow: auto;
    }
    .credit-info-head {
      display: flex;
      justify-content: space-between;
      margin: 0px 28px;
      padding-bottom: 15px;

      .credit-info-head-left,
      .credit-info-head-right {
        display: flex;
        .credit-icon {
          width: 30px;
          height: 31px;
          margin-right: 20px;
        }
        .credit-title {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #333333;
          padding-bottom: 6px;
        }
        .credit-grade {
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #65960f;
        }
        .credit-fraction {
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #1d84ff;
        }
      }
    }
    .credit-info-list {
      background: #f1f3f6;
      height: calc(100% - 126px);
      overflow: auto;
    }
  }
  .isOverflow {
    overflow: auto;
  }
}
</style>
